import * as React from 'react';
import type { CallToActionProps } from 'core/components/CallToAction/CallToAction';
import CallToAction from 'core/components/CallToAction';
import { GatsbyLinkProps, Link } from 'gatsby';
import { BOOKING_URL } from 'core/constants';
import useTrackBookingStarted from 'analytics/ttd/hooks/useTrackBookingStarted';
import type { PreselectBookingData } from '../../lib/types';
import { getBookingStepUrl } from '../../lib/utils';

export type StartBookingButtonProps = Partial<CallToActionProps> &
    Omit<PreselectBookingData, 'date'> & {
        gaEventName?: string;
    };

export default function StartBookingButton({
    locationId,
    citySlug,
    locationSlug,
    gaEventName,
    ...props
}: StartBookingButtonProps) {
    const to = React.useMemo(() => {
        switch (true) {
            case !!locationSlug && !!citySlug:
                return getBookingStepUrl('date', citySlug, locationSlug);
            case !!citySlug:
                return getBookingStepUrl('location', citySlug, '');
            default:
                return `/${BOOKING_URL}/city`;
        }
    }, [citySlug, locationSlug]);
    const trackBookingStarted = useTrackBookingStarted(gaEventName);

    return (
        <CallToAction
            Component={Link}
            state={{ locationId }}
            {...(props as GatsbyLinkProps<unknown>)}
            to={to}
            onClick={trackBookingStarted}
        />
    );
}
